<template>
    <div class="designer">
        <b-tabs :fill="screenWidth <= 700" pills card content-class="mt-3" v-model="activeStep" class="designer-tabs" header-class="designer-header" @activate-tab="showContent()" >
            
            <b-tab :title-link-class="{'completed':step1Complete && activeStep > 0}" @click="scrollTop()" >
                <template v-slot:title>
                        1 <span class="d-none d-sm-inline" v-bind:class="{'d-inline': activeStep==0}">Personalize</span> <svg v-if="step1Complete" class="step-check" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" > <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </template>
                <Personalization @updateStep1="setStep1"/>
            </b-tab>
            <b-tab :title-link-class="{'disabled':step2Disabled, 'completed':step2Complete && activeStep > 1}" @click="scrollTop()">
                <template v-slot:title>
                        2 <span class="d-none d-sm-inline" v-bind:class="{'d-inline': activeStep==1}">Front of Page</span> <svg v-if="step2Complete" class="step-check" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" > <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </template>
                <Step2  @updateStep2="setStep2" ref="Step2"/>
            </b-tab>
            <b-tab  :title-link-class="{'disabled':step3Disabled, 'completed':step3Complete && activeStep > 2}" @click="scrollTop()">
                <template v-slot:title>
                        3 <span class="d-none d-sm-inline" v-bind:class="{'d-inline': activeStep==2}">Back of Page</span> <svg v-if="step3Complete" class="step-check" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" > <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </template>
                <Step3 @updateStep3="setStep3" ref="Step3"  :journalProperties="journalProperties"/>
            </b-tab>
            <b-tab :title-link-class="{'disabled':step4Disabled, 'completed':step4Complete && activeStep > 3}" @click="scrollTop()">
                <template v-slot:title>
                        4 <span class="d-none d-sm-inline" v-bind:class="{'d-inline': activeStep==3}">Preview</span> 
                </template>
                <Step4 @updateStep4="setStep4" @goBack="goBack" ref="Step4" :journalProperties="journalProperties"/>
            </b-tab>
        </b-tabs>
  

    </div>
    
</template>

<style >
     .nav-link{
        font-size: 13px !important;
    }
</style>

<script>
import Personalization from './Personalization'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
var VueScrollTo = require('vue-scrollto');

export default {
    name: 'Designer',
    data: function(){
        return{
            step1Complete: false,
            step2Complete: false,
            step3Complete: false,
            step4Complete: false,

            step2Disabled: true,
            step3Disabled : true,
            step4Disabled:true,
            activeStep:0,
            journalProperties:{
                journalOwner:"",
                frontPage:{},
                backPage:{}
            },
            screenWidth:1200
        }
    },
    components: {
        Personalization,
        Step2: Step2,
        Step3: Step3,
        Step4: Step4
    },
    mounted(){
        window.addEventListener("resize", ()=> this.screenWidth = screen.width);
    },
    methods: {
        setStep1(v) {
            this.step1Complete = true;
            this.journalProperties.journalOwner = v;
            this.step2Disabled = false;
            this.activeStep = 1;
            this.scrollTop();

        },
        setStep2(v) {
            this.journalProperties.frontPage = v;
            this.step2Complete = true;
            this.activeStep =2;
            this.step3Disabled = false;
            this.scrollTop();
    
        },
        setStep3(v) {
           this.journalProperties.backPage = v;
            this.step3Complete = true;
            this.activeStep =3;
            this.step4Disabled = false;
            this.scrollTop();
            
        },
        setStep4(v) {
           this.journalProperties.backPage = v;
            this.step3Complete = true;
            this.activeStep =3;
            this.step4Disabled = false;
            this.scrollTop();
 
        },
        scrollTop(){
            VueScrollTo.scrollTo(".card-header", 100, {offset: -10});
        },
        goBack(){
            this.setStep1();
            this.scrollTop();
        },
        showContent:function(){

            this.$refs.Step2.scaleFrontPage();
            this.$refs.Step2.activeSection = null;

            this.$refs.Step3.scaleBackPage();
            this.$refs.Step3.activeSection = null;

            this.$refs.Step4.scaleReviewPage();
            this.$refs.Step4.activeSection = null;
            this.$refs.Step4.resetPages();
        }
    }
}


</script>